import React from 'react'
import { GridApi } from 'ag-grid-community'
import { CollateralBasketColumnId, CollectionColumnId } from 'view/routes/ColumnNames'
import { Locale, Translation } from 'locale'
import { GroupByToggles, GroupsMap } from 'view/components/datagrid'
import { DealsGridColumnId } from '../DealsGridColumnNames'

interface DealsGroupByTogglesProps {
  gridApi: GridApi | null
}

const dealGroupsMap: GroupsMap = {
  UNGROUPED: {
    rowGroupColumnIds: [],
    columnState: { defaultState: { sort: null } },
    name: Locale.translate(Translation.TC_GROUPING_UNGROUPED)
  },
  COUNTERPARTY: {
    rowGroupColumnIds: [DealsGridColumnId.COUNTERPARTY_NAME],
    columnState: { defaultState: { sort: null } },
    name: Locale.translate(Translation.TC_GROUPING_COUNTERPARTY)
  },
  COLLECTIONS: {
    rowGroupColumnIds: [CollectionColumnId.COLLECTION_NAME],
    columnState: { defaultState: { sort: null } },
    name: Locale.translate(Translation.TC_GROUPING_COLLECTIONS)
  },
  BASKETS: {
    rowGroupColumnIds: [CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID],
    columnState: { state: [{ colId: CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID, sort: 'asc' }] },
    name: Locale.translate(Translation.TC_GROUPING_BASKETS)
  },
  COLLECTIONS_BASKETS: {
    rowGroupColumnIds: [CollectionColumnId.COLLECTION_NAME, CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID],
    columnState: { state: [{ colId: CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID, sort: 'asc' }] }
  },
  COUNTERPARTY_COLLECTIONS: {
    rowGroupColumnIds: [DealsGridColumnId.COUNTERPARTY_NAME, CollectionColumnId.COLLECTION_NAME],
    columnState: {
      defaultState: { sort: null }
    }
  },
  COUNTERPARTY_BASKETS: {
    rowGroupColumnIds: [DealsGridColumnId.COUNTERPARTY_NAME, CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID],
    columnState: { state: [{ colId: CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID, sort: 'asc' }] }
  },
  COUNTERPARTY_COLLECTIONS_BASKETS: {
    rowGroupColumnIds: [
      DealsGridColumnId.COUNTERPARTY_NAME,
      CollectionColumnId.COLLECTION_NAME,
      CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID
    ],
    columnState: { state: [{ colId: CollateralBasketColumnId.COLLATERAL_BASKET_DEAL_ID, sort: 'asc' }] }
  }
}

export const DealsGroupByToggles: React.FC<DealsGroupByTogglesProps> = ({ gridApi }) => {
  return <GroupByToggles gridApi={gridApi} groupsMap={dealGroupsMap} />
}
